export default __webpack_public_path__ + "5bd8d03df5227ac830eb9ed9afedc881.ttf";